// extracted by mini-css-extract-plugin
export default {"PrivacyPolicyWrapper":"PrivacyPolicyPage_PrivacyPolicyWrapper__fSClR","PrivacyPolicy":"PrivacyPolicyPage_PrivacyPolicy__E9Bf5"};